import React from 'react'
export default function NotFound(){
    return(<>
    <h1 style={{color:"white", margin:"10%",fontFamily: "'Bebas Neue', sans-serif"}}><span style={{fontSize:"130px"}}>404</span><br/> Page not found :(</h1>
    </>)
}